var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75032 13.3958H5.68782C3.81283 13.3958 2.29199 11.875 2.29199 10C2.29199 9.0625 2.67741 8.20833 3.29199 7.59375C3.90658 6.97917 4.76074 6.59375 5.69824 6.59375H8.75032M11.2503 13.3958H14.3128C15.2503 13.3958 16.1045 13.0104 16.7191 12.3958C17.3337 11.7812 17.7191 10.9271 17.7191 9.98958C17.7191 8.11458 16.1982 6.59375 14.3232 6.59375H11.2503M7.07324 10H12.9274",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlIcon);
export default __webpack_public_path__ + "static/media/url-icon.42d668bda647eccaa3f3dac27aaacc1c.svg";
export { ForwardRef as ReactComponent };